// material-ui
import { Box, Typography } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import React, { useEffect } from 'react';
import { UserAuthContext } from 'context/UserAuthContext';
import admin from 'menu-items/admin';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
    const { getUserFromStorage, isAdmin } = React.useContext(UserAuthContext);
    const [ menuItems, setMenuItems] = React.useState(menuItem.items);
    const user = getUserFromStorage();

    useEffect(()=>{
        if(isAdmin()){
            setMenuItems([admin, ...menuItems]);
        }
    }, []);

    const navGroups = menuItems.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} user={user} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Fix - Navigation Group
                    </Typography>
                );
        }
    });

    return <Box sx={{ paddingTop: '70px' }}>{navGroups}</Box>;
};

export default Navigation;
